import React, { Component } from 'react';
import { message, Button, Icon, Input, InputNumber, Checkbox, Popconfirm, Card, List, Table, Select } from 'utils/ui';
import { FaTicketAlt, FaUtensils, FaDAndD, FaCampground, FaRegGem, FaGamepad, FaChess, FaTv, FaBlender, FaBath, FaHome, FaTableTennis, FaStar, FaThLarge, FaListUl, FaTimes } from 'react-icons/fa'
import { deleteGift, editGift } from '../api_calls/gift';
import { observer } from 'mobx-react';
import _ from 'underscore';
import FamilyStore from '../stores/FamilyStore';
import { toSafeExternalUrl } from '../utils/gifts/helpers';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import FormField from '../common/FormField';
const { TextArea } = Input;
const { Meta } = Card;

const colourMap = {
    "1": "gold",
    "2": "#1890ff",
    // "3": "bronze"
}

@observer(['AuthStore', 'UserStore', 'MyListStore', 'FamilyStore'])
class GiftCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            description: "",
            link: "",
            imageLink: "",
            price: 0,
            quantityWanted: 1,
            isInfinite: false,
            modalOpen: false,
            giftDescriptionModalOpen: false,
            submittingEdits: false,
            displayMode: this.readDisplayMode(),
            isMobileView: this.readIsMobileView(),
            testImg: ""
        };
        this.confirmDelete = this.confirmDelete.bind(this);
        this.showEditModal = this.showEditModal.bind(this);
        this.onSubmitEdits = this.onSubmitEdits.bind(this);
        this.padded = this.padded.bind(this);
        this.determineCategoryIcon = this.determineCategoryIcon.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.getCurrentAuthToken = this.getCurrentAuthToken.bind(this);
        this.getCurrentUserId = this.getCurrentUserId.bind(this);
        // this.getGiftInfo("https://cors-anywhere.herokuapp.com/https://en.wikipedia.org/wiki/George_Washington");
    }

    componentDidMount() {
        if (typeof window !== "undefined") {
            window.addEventListener("resize", this.handleViewportChange);
        }
        this.handleViewportChange();
    }

    componentWillUnmount() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.handleViewportChange);
        }
    }

    readIsMobileView() {
        if (typeof window === "undefined") {
            return false;
        }
        return window.matchMedia("(max-width: 900px)").matches;
    }

    handleViewportChange() {
        const isMobileView = this.readIsMobileView();
        if (isMobileView !== this.state.isMobileView) {
            this.setState({ isMobileView });
        }
        if (isMobileView && this.state.displayMode !== "cards") {
            this.setState({ displayMode: "cards" });
            try {
                window.localStorage.setItem("myListGiftDisplayMode", "cards");
            } catch (error) {
                // Ignore persistence errors and keep runtime state.
            }
        }
    }

    getCategoryOptions() {
        return [
            { value: 'gift', label: 'Gift (General)' },
            { value: 'books', label: 'Books' },
            { value: 'camping', label: 'Camping' },
            { value: 'clothing', label: 'Clothing' },
            { value: 'tools', label: 'Tools' },
            { value: 'art', label: 'Art' },
            { value: 'food', label: 'Food' },
            { value: 'appliances', label: 'Appliances' },
            { value: 'cosmetics', label: 'Cosmetics' },
            { value: 'technology', label: 'Technology' },
            { value: 'household', label: 'Household' },
            { value: 'board games', label: 'Board Games' },
            { value: 'video games', label: 'Video Games' },
            { value: 'jewelry', label: 'Jewelry' },
            { value: 'gift cards', label: 'Gift Cards' },
            { value: 'tickets', label: 'Tickets' },
            { value: 'd&d', label: 'Dungeons and Dragons' },
            { value: 'toys', label: 'Toys' }
        ];
    }

    readDisplayMode() {
        try {
            const mode = window.localStorage.getItem("myListGiftDisplayMode");
            return mode === "table" ? "table" : "cards";
        } catch (error) {
            return "cards";
        }
    }

    setDisplayMode(mode) {
        if (this.state.isMobileView) {
            return;
        }
        const normalized = mode === "table" ? "table" : "cards";
        this.setState({ displayMode: normalized });
        try {
            window.localStorage.setItem("myListGiftDisplayMode", normalized);
        } catch (error) {
            // Ignore persistence errors and keep runtime state.
        }
    }

    getCurrentAuthToken() {
        const { UserStore, AuthStore } = this.props;
        return UserStore.childViewActive ? UserStore.activeChild.jwt : AuthStore.userAuth.auth.accessToken;
    }

    getCurrentUserId() {
        const { UserStore } = this.props;
        return UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
    }

    confirmDelete(gift) {
        const { MyListStore, FamilyStore } = this.props;
        const currentUserId = this.getCurrentUserId();
        deleteGift(gift, this.getCurrentAuthToken()).then(() => {
            MyListStore.loadGiftsForUser(currentUserId, currentUserId, FamilyStore.activeGroupId);
        });
    }

    showEditModal(gift) {
        console.log(gift);
        this.setState({
            modalOpen: true,
            id: gift._id,
            title: gift.title,
            description: gift.description,
            category: gift.category,
            link: gift.link,
            price: gift.price,
            quantityWanted: gift.quantityWanted,
            isInfinite: gift.isInfinite
        });
    }

    onSubmitEdits() {
        let self = this;
        const currentUserId = this.getCurrentUserId();
        self.setState({ submittingEdits: true });
        editGift(this.state.id, this.state.title, this.state.description, this.state.link, this.state.category, this.state.price, this.state.quantityWanted, this.state.isInfinite, this.getCurrentAuthToken()).then(() => {
            self.setState({ submittingEdits: false, modalOpen: false });
            self.props.MyListStore.loadGiftsForUser(currentUserId, currentUserId, self.props.FamilyStore.activeGroupId);
            message.success("Edits submitted");
        });
    }

    padded(stringToPad, gift) {
        let teaserStringLength = 30;
        let teaserString;
        if (stringToPad.length === 0) {
            return <span><br /><br /></span>;
        }
        else if (stringToPad.length <= teaserStringLength) {
            return <span>{stringToPad}</span>;
        } else {
            teaserString = stringToPad.slice(0, teaserStringLength) + "...";
            return <Button onClick={() => {
                this.setState({
                    descriptionTitle: gift.title,
                    descriptionText: stringToPad,
                    descPrice: gift.price,
                    giftDescriptionModalOpen: true
                })
            }}>{teaserString}</Button>;
        }
    }

    determineCategoryIcon(category, chosenFontSize = 70) {
        let icon;
        let iconFontSize = String(chosenFontSize).concat("pt");
        switch (category) {
            case ("books"):
                icon = <Icon type="book" style={{ fontSize: iconFontSize }} />;
                break;
            case ("camping"):
                icon = <FaCampground style={{ fontSize: iconFontSize }} />;
                break;
            case ("clothing"):
                icon = <Icon type="skin" style={{ fontSize: iconFontSize }} />;
                break;
            case ("tools"):
                icon = <Icon type="tool" style={{ fontSize: iconFontSize }} />;
                break;
            case ("art"):
                icon = <Icon type="picture" style={{ fontSize: iconFontSize }} />;
                break;
            case ("food"):
                icon = <FaUtensils style={{ fontSize: iconFontSize }} />;
                break;
            case ("appliances"):
                icon = <FaBlender style={{ fontSize: iconFontSize }} />;
                break;
            case ("cosmetics"):
                icon = <FaBath style={{ fontSize: iconFontSize }} />;
                break;
            case ("technology"):
                icon = <FaTv style={{ fontSize: iconFontSize }} />;
                break;
            case ("household"):
                icon = <FaHome style={{ fontSize: iconFontSize }} />;
                break;
            case ("board games"):
                icon = <FaChess style={{ fontSize: iconFontSize }} />;
                break;
            case ("video games"):
                icon = <FaGamepad style={{ fontSize: iconFontSize }} />;
                break;
            case ("jewelry"):
                icon = <FaRegGem style={{ fontSize: iconFontSize }} />;
                break;
            case ("gift cards"):
                icon = <Icon type="credit-card" style={{ fontSize: iconFontSize }} />;
                break;
            case ("tickets"):
                icon = <FaTicketAlt style={{ fontSize: iconFontSize }} />;
                break;
            case ("d&d"):
                icon = <FaDAndD style={{ fontSize: iconFontSize }} />;
                break;
            case ("toys"):
                icon = <FaTableTennis style={{ fontSize: iconFontSize }} />;
                break;
            default: icon = <Icon type="gift" style={{ fontSize: iconFontSize }} />;
        }
        return icon;
    }

    render() {
        const { UserStore } = this.props;
        const theme = UserStore.theme();
        const toggleActiveStyle = {
            backgroundColor: theme.icons || "#1890ff",
            borderColor: theme.icons || "#1890ff",
            color: theme.font2 || "#fff",
            boxShadow: "0 6px 14px rgba(0,0,0,0.12)"
        };
        const toggleInactiveStyle = {
            backgroundColor: "rgba(255,255,255,0.82)",
            borderColor: theme.darkBackground || "#d9d9d9",
            color: theme.darkBackground || "#222"
        };
        const categoryOptions = this.getCategoryOptions();
        let gifts = this.props.gifts;
        if (this.props.sort && FamilyStore.activeGroup && FamilyStore.activeGroup.settings.allowRankings) {
            gifts.forEach((gift) => {
                delete gift.rank;
                if (this.props.ranks[gift._id]) {
                    gift.rank = this.props.ranks[gift._id];
                }
            });
            gifts = _.sortBy(gifts, thisGift => thisGift.rank || Infinity);
        }
        else {
            gifts.forEach((gift) => {
                delete gift.rank;
            })
            gifts = _.sortBy(gifts, thisGift => Math.random() * 100);
        }
        const re = /^(?:https?:\/\/)?(?:www\.)?(?:[^\/]+\.)?([A-Za-z0-9-]+)\.[A-Za-z]{2,}(?:[\/:]|$)/i;
        const listItems = gifts.map((gift) =>
            {
                const safeGiftLink = toSafeExternalUrl(gift.link);
                return (
            <List.Item key={gift._id.toString()} style={{ padding: "12px", backgroundColor: UserStore.theme().appBackground }}>
                <Card
                    actions={[
                        <Button
                            key="edit"
                            style={{ borderColor: "#d9d9d9", color: "#222", background: "#fff", fontWeight: 600 }}
                            onClick={this.showEditModal.bind(this, gift)}
                        >
                            <Icon type="edit" style={{ marginRight: 8 }} />EDIT
                        </Button>,
                        <Popconfirm key="delete" title="Are you sure you want to delete this gift?" onConfirm={this.confirmDelete.bind(this, gift._id)} okText="Yes" cancelText="No">
                            <Button style={{ backgroundColor: "#ff4d4f", borderColor: "#ff4d4f", color: "#fff", fontWeight: 600 }}>
                                <Icon type="delete" style={{ marginRight: 8 }} />DELETE
                            </Button>
                        </Popconfirm>
                    ]}
                    actionsClassName="gift-card-actions"
                    cover={
                        <div style={{
                            width: "100%",
                            height: 168,
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            borderTopLeftRadius: 6,
                            borderTopRightRadius: 6
                        }}>
                            {safeGiftLink ? <a href={safeGiftLink} target="_blank" rel="noopener noreferrer" style={{ width: "100%", display: "block" }}>
                                {gift.imageLink
                                    ? <img
                                        alt={gift.title || "gift image"}
                                        src={gift.imageLink}
                                        style={{
                                            width: "100%",
                                            height: 168,
                                            objectFit: "cover",
                                            display: "block"
                                        }}
                                    />
                                    : <div style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: 24
                                    }}>
                                        {this.determineCategoryIcon(gift.category, 56)}
                                    </div>
                                }
                            </a> : <div style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 24
                            }}>
                                {this.determineCategoryIcon(gift.category, 56)}
                            </div>}
                        </div>
                    }
                    bordered={false}
                    style={{
                        backgroundColor: "#ffffff",
                        borderRadius: 8,
                        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                        minHeight: "24rem",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        overflow: "visible"
                    }}
                >
                    {/* Rank badge (top-left) */}
                    {gift.rank ? (
                        <div style={{
                            position: "absolute",
                            left: 12,
                            top: 12,
                            zIndex: 2,
                            backgroundColor: colourMap[gift.rank] || "#ffd666",
                            color: "#fff",
                            padding: "6px 10px",
                            borderRadius: 6,
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)"
                        }}>
                            <span style={{ marginRight: 6 }}>{gift.rank}</span>
                            {gift.rank === 1 ? <FaStar /> : null}
                        </div>
                    ) : null}

                    {/* Price badge (top-right) */}
                    <div style={{
                        position: "absolute",
                        right: 12,
                        top: 12,
                        zIndex: 2,
                        backgroundColor: "#fff",
                        color: "#1890ff",
                        padding: "6px 10px",
                        borderRadius: 6,
                        fontWeight: 700,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                    }}>
                        ${gift.price.toFixed(2)}
                    </div>
                    <div style={{ minHeight: 32, display: "flex", alignItems: "center" }}>
                        {gift.isInfinite ? (<div style={{
                            background: "#fff1f0",
                            color: "#e272c6",
                            padding: "6px 10px",
                            borderRadius: 20,
                            fontWeight: 700,
                            fontSize: "13px",
                            border: "1px solid #ffd8d8"
                        }}>Always Wanted</div>) : ""}
                        {gift.quantityWanted > 1 && !gift.isInfinite ? (<div style={{
                            background: "#fff1f0",
                            color: "#e272c6",
                            padding: "6px 10px",
                            borderRadius: 20,
                            fontWeight: 700,
                            fontSize: "13px",
                            border: "1px solid #ffd8d8",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8
                        }}>
                            Want {gift.quantityWanted}
                        </div>) : ""}
                    </div>
                    <div style={{ paddingTop: 12, paddingLeft: 8, paddingRight: 8, paddingBottom: 12, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                        <div style={{ marginBottom: 8 }}>
                            <div style={{
                                fontSize: 16,
                                fontWeight: 700,
                                color: "#111",
                                marginBottom: 6,
                                lineHeight: 1.2,
                                wordBreak: "break-word",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                minHeight: "2.4em"
                            }}>{gift.title}</div>

                            <div style={{
                                fontSize: 13,
                                color: "#555",
                                lineHeight: 1.4,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                minHeight: "3.6em"
                            }}>
                                {gift.description || <span style={{ color: "#bfbfbf" }}>No description provided.</span>}
                            </div>
                        </div>

                        <div style={{ marginTop: "auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                {/* Small category chip */}
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    padding: "4px 8px",
                                    backgroundColor: "#f0f2f5",
                                    borderRadius: 14,
                                    color: "#333",
                                    fontSize: 11
                                }}>
                                    <span style={{ display: "flex", alignItems: "center" }}>
                                        {this.determineCategoryIcon(gift.category, 14)}
                                    </span>
                                    <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{gift.category}</span>
                                </div>
                            </div>

                            {/* Actions hint for keyboard/mobile */}
                            <div style={{ color: "#999", fontSize: 11 }}>
                                {gift.link ? gift.link.match(re) && gift.link.match(re)[1] : " "}
                            </div>
                        </div>
                    </div>
                </Card>
            </List.Item>
                );
            }
        );
        const tableDataSource = gifts.map((gift) => {
            const safeGiftLink = toSafeExternalUrl(gift.link);
            const domain = safeGiftLink && safeGiftLink.match(re) ? safeGiftLink.match(re)[1] : safeGiftLink;
            return {
                key: gift._id.toString(),
                title: gift.title,
                price: `$${Number(gift.price || 0).toFixed(2)}`,
                category: <span style={{ textTransform: "capitalize" }}>{gift.category || "uncategorized"}</span>,
                quantity: gift.isInfinite ? "Always Wanted" : `Want ${gift.quantityWanted || 1}`,
                description: gift.description ? this.padded(gift.description, gift) : <span style={{ color: "#bfbfbf" }}>No description provided.</span>,
                link: safeGiftLink ? <a href={safeGiftLink} target="_blank" rel="noopener noreferrer">{domain}</a> : <span style={{ color: "#bfbfbf" }}>none</span>,
                actions: <div style={{ display: "flex", gap: 8, minWidth: 190 }}>
                    <Button style={{ borderColor: "#d9d9d9", color: "#222", background: "#fff", fontWeight: 600 }} onClick={this.showEditModal.bind(this, gift)}>
                        <Icon type="edit" style={{ marginRight: 8 }} />EDIT
                    </Button>
                    <Popconfirm title="Are you sure you want to delete this gift?" onConfirm={this.confirmDelete.bind(this, gift._id)} okText="Yes" cancelText="No">
                        <Button style={{ backgroundColor: "#ff4d4f", borderColor: "#ff4d4f", color: "#fff", fontWeight: 600 }}>
                            <Icon type="delete" style={{ marginRight: 8 }} />DELETE
                        </Button>
                    </Popconfirm>
                </div>
            };
        });
        const tableColumns = [
            { title: "Title", dataIndex: "title", key: "title" },
            { title: "Price", dataIndex: "price", key: "price" },
            { title: "Category", dataIndex: "category", key: "category" },
            { title: "Quantity", dataIndex: "quantity", key: "quantity" },
            { title: "Description", dataIndex: "description", key: "description" },
            { title: "Link", dataIndex: "link", key: "link" },
            { title: "Actions", dataIndex: "actions", key: "actions" }
        ];
        const showingTable = !this.state.isMobileView && this.state.displayMode === "table";
        return (
            <div style={{ backgroundColor: UserStore.theme().appBackground || "white" }}>
                <ModalShell
                    className="edit-modal"
                    overlayClassName="edit-modal-overlay"
                    isOpen={this.state.modalOpen}
                    onRequestClose={() => { (this.state.submittingEdits ? console.log("tried to close") : this.setState({ modalOpen: false })) }}
                    maxWidth={760}
                    top="44%"
                >
                    {(!this.state.submittingEdits ?
                        <ModalBody>
                            <div className="ui-modal-stack">
                                <FormField label="Title">
                                    <Input
                                        size="large"
                                        maxLength={60}
                                        value={this.state.title}
                                        onChange={(e) => { this.setState({ title: e.target.value }) }}
                                        placeholder="Brand Name Widget"
                                        style={{ borderRadius: 6 }}
                                    />
                                </FormField>

                                <FormField label="Description" style={{ marginTop: 6 }}>
                                    <TextArea
                                        onChange={(e) => { this.setState({ description: e.target.value }) }}
                                        placeholder="This is a..."
                                        value={this.state.description}
                                        autosize={{ minRows: 3, maxRows: 6 }}
                                        style={{ borderRadius: 6 }}
                                    />
                                </FormField>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                                    <div style={{ flex: '1 1 160px', minWidth: 140 }}>
                                        <FormField label="Price">
                                            <InputNumber
                                                style={{ width: '100%', borderRadius: 6 }}
                                                defaultValue={0.00}
                                                min={0}
                                                value={this.state.price}
                                                size="large"
                                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                onChange={(value) => { this.setState({ price: value }) }}
                                            />
                                        </FormField>
                                    </div>

                                    <div style={{ flex: '2 1 240px', minWidth: 180 }}>
                                        <FormField label="Link">
                                            <Input
                                                size="large"
                                                value={this.state.link}
                                                onChange={(e) => { this.setState({ link: e.target.value }) }}
                                                placeholder="https://example.com/..."
                                                style={{ borderRadius: 6 }}
                                            />
                                        </FormField>
                                    </div>

                                    <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                                        <FormField label="Quantity Desired">
                                            <InputNumber
                                                style={{ width: '90%', borderRadius: 6 }}
                                                defaultValue={this.state.quantityWanted}
                                                min={1}
                                                size="large"
                                                disabled={this.state.isInfinite}
                                                onChange={(value) => { this.setState({ quantityWanted: value }) }}
                                            />
                                        </FormField>
                                    </div>
                                    <div style={{ flex: '1 1 10px', minWidth: 10 }}>
                                        or
                                    </div>

                                    <div style={{ flex: '1 1 80px', minWidth: 80 }}>
                                        <span style={{ fontWeight: 'bold' }}>Always Wanted</span> <Checkbox defaultChecked={this.state.isInfinite} onChange={(value) => { this.setState({ isInfinite: value.target.checked }) }} />
                                    </div>

                                    <div style={{ flex: '1 1 180px', minWidth: 160 }}>
                                        <FormField label="Category">
                                            <Select
                                                value={this.state.category || 'gift'}
                                                onChange={(value) => { this.setState({ category: value }) }}
                                                style={{ width: '100%', borderRadius: 6 }}
                                            >
                                                {categoryOptions.map((option) => (
                                                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                                ))}
                                            </Select>
                                        </FormField>
                                    </div>
                                </div>


                                <div className="ui-modal-actions">
                                    <Button
                                        className="AppFont btn-cancel ui-btn-danger"
                                        onClick={() => { this.setState({ modalOpen: false }) }}
                                        size="large"
                                    >
                                        <Icon type="close" /> Cancel
                                    </Button>

                                    <Button
                                        className="AppFont btn-submit ui-btn-success"
                                        onClick={this.onSubmitEdits}
                                        size="large"
                                    >
                                        <Icon type="check-circle" /> Submit
                                    </Button>
                                </div>
                            </div>
                        </ModalBody>

                        : <Icon type="loading" style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: 'translate("-50%", "-50%")', fontSize: "50pt"
                        }} />)}
                </ModalShell>
                <ModalShell className="gift-description-modal" overlayClassName="gift-description-modal-overlay"
                    isOpen={this.state.giftDescriptionModalOpen}
                    onRequestClose={() => { this.setState({ giftDescriptionModalOpen: false }) }}>
                    <ModalBody>
                    <div style={{ textAlign: "center", position: "relative" }}>
                        <button
                            type="button"
                            className="gift-modal-close-btn"
                            aria-label="Close gift description"
                            onClick={() => { this.setState({ giftDescriptionModalOpen: false }) }}
                        >
                            <FaTimes />
                        </button>
                        <span className="AppFont" style={{ fontSize: "3em" }}>{this.state.descriptionTitle}</span>
                        <br />
                        <span style={{ color: "#198532", fontSize: "4em" }}>${this.state.descPrice}</span>
                        <p style={{ fontSize: "22pt" }}>{this.state.descriptionText}</p>
                    </div>
                    </ModalBody>
                </ModalShell>
                <div style={{ width: "100%", maxWidth: 1100, margin: "0 auto", padding: "0 18px", boxSizing: "border-box" }}>
                    {this.state.isMobileView ? null : (
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 14 }}>
                            <Button
                                onClick={() => { this.setDisplayMode("cards") }}
                                style={showingTable ? toggleInactiveStyle : toggleActiveStyle}
                            >
                                <FaThLarge style={{ marginRight: 8 }} />Cards
                            </Button>
                            <Button
                                onClick={() => { this.setDisplayMode("table") }}
                                style={showingTable ? toggleActiveStyle : toggleInactiveStyle}
                            >
                                <FaListUl style={{ marginRight: 8 }} />Table
                            </Button>
                        </div>
                    )}

                    {showingTable ? (
                        <Table dataSource={tableDataSource} columns={tableColumns} />
                    ) : (
                        <List
                            grid={{
                                gutter: 16, xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 3,
                            }}
                        >
                            {listItems}
                        </List>
                    )}
                </div>
            </div>
        );
    }
}
export default GiftCards;